//import 'slick-carousel';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);



var Init = function(){
  var $window = $(window);
  var $html = $("html");

  var pointSwiper = void 0;

  // Resize
  var _isSP;
  var Resize = function(){
    if($window.width() < 751){
      _isSP = true;
      if(!$(".point-content").hasClass("swiper-initialized")){
        pointSwiper = new Swiper('.point-content', {
          spaceBetween: 50,
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
        });
      }

    }else{
      _isSP = false;
      if($(".point-content").hasClass("swiper-initialized")){
        pointSwiper.destroy(false,true);
        pointSwiper = void 0;
      }
      if($navSP !== void 0 && $navSP.hasClass("nav-open")){
        SPNavClose();
      }
    }
  };

  $window.on("resize", Resize);
  Resize();

  // MODAL
  var SelectModalOpen = function(event){
    // console.log("SelectModalOpen");
    var _$target = $(event.currentTarget);
    var _parentId = _$target.data("modal-id");
    var _id = _$target.data("modal-content");
    var $modal = $("#" + _parentId);
    var $modalWrap = $modal.find(".modal-wrap");
    var $modalOverlay = $modal.find(".modal-overlay");
    var $modalClose = $modal.find(".modal--close, .modal-close");
    var $modalContents = $modal.find(".modal-content");
    $html.addClass("is-modal");
    // console.log("SelectModalOpen");
    $modalContents.each(function(){
      var __$this = $(this);
      var __$parent = __$this.parent();
      if(__$this.data("modal-content") === _id){
        var _url = __$this.data("modal-url");
        var _color = __$this.data("modal-color");
        var _overlay = __$this.data("modal-overlay");
        var _opacity = __$this.data("modal-opacity") * 1;

        if(_url !== void 0){
          if(_color !== void 0){
            __$parent.css({
              "background": "url(" + _url + ") center 0 / 100% auto " + _color
            });
          }else{
            __$parent.css({
              "background": "url(" + _url + ") center 0 / 100% 100%"
            });
          }
        }else if(_color !== void 0){
          __$parent.css({
            "background": _color
          });
        }
        __$this.addClass("modal-content--open");
        $modalOverlay.css({
          "background": _overlay,
          opacity: _opacity,
        });
      }
    });
    $modal.css({display: "block"});
    $modalWrap.scrollTop(0);
    $modalOverlay.on("click", SelectModalClose);
    $modalClose.on("click", SelectModalClose);
    if(_parentId === "modal_nav"){
      //console.log(_parentId);
      $navSPBtn.on("click", SelectModalClose);
    }
  };
  var SelectModalClose = function(){
    // console.log("SelectModalClose");
    var $modal = $(".modal");
    var $modalOverlay = $modal.find(".modal-overlay");
    var $modalClose = $modal.find(".modal--close, .modal-close");
    var $modalContents = $modal.find(".modal-content");
    $modal.css({display: ""});
    $html.removeClass("is-modal");
    $modalContents.each(function(){
      var __$this = $(this);
      __$this
        .css({"background": ""})
        .removeClass("modal-content--open");
    });
    $modalOverlay.css({
      "background": "",
      opacity: "",
    });

    $modalOverlay.off("click", SelectModalClose);
    $modalClose.off("click", SelectModalClose);
    $navSPBtn.off("click", SelectModalClose);
  };
  $("body").on("click", ".modal--btn", SelectModalOpen);


  var $navSP = $("#nav_sp");
  var $navSPContent = $navSP.find(".nav-wrap");
  var $navSPBtn = $("#nav_btn_sp");
  var $nav = $(".nav a");
  var NavClick = function(event){
    var $a = $(event.currentTarget);
    var _hash = $a.attr("href");
    var $target = $(_hash);
    var _offset = $target.offset().top;

    if(_hash !== "" && _hash !== "#" && _offset !== void 0){
      if(_isSP){
        _offset -= $navSP.outerHeight();
        SPNavClose();
      }
      $("html, body").animate({scrollTop: _offset}, 300);
    }

    return false;
  };
  $nav.on("click", NavClick);

  var SPNavOpenClose = function(){
    if($navSP.hasClass("nav-open")){
      SPNavClose();
    }else{
      $navSP.addClass("nav-open");
      $html.addClass("is-modal");
      $navSPContent.scrollTop(0);
    }
  };
  var SPNavClose = function(){
    $navSP.removeClass("nav-open");
    $html.removeClass("is-modal");
  };
  $navSPBtn.on("click", SPNavOpenClose);

  // SLIDER
  var styleSwiper = new Swiper('.style-content', {
    loop: true,
    autoplay: true,
    spaceBetween: 5,
    slidesPerView: 2,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      // when window width is >= 320px
      751: {
        spaceBetween: 12,
        slidesPerView: 4,
      },
    }
  });

  var newsSwiper = new Swiper('.news-content', {
    spaceBetween: 0,
    slidesPerView: 1,
    navigation: {
      nextEl: ".news--next",
      prevEl: ".news--prev",
    },
    breakpoints: {
      // when window width is >= 320px
      751: {
        spaceBetween: 12.5,
        slidesPerView: 3,
      },
    }
  });


  // FAQ
  var $faqs = $(".faq-box");
  var $aHeads = $(".faq-a--head");
  var FaqOpenClose = function(event){
    var _$this = $(event.currentTarget);
    var _targetId = _$this.data("faq");

    $faqs.each(function(){
      var _$faq = $(this);
      var _faqId = _$faq.data("faq");

      if(_targetId === _faqId){
        if(_$faq.hasClass("faq-box-open")){
          _$faq.removeClass("faq-box-open");
        }else{
          _$faq.addClass("faq-box-open");
        }
      }
    });
  };
  $aHeads.on("click", FaqOpenClose);

  // ScrollAnimatiopn
  window.AnimationStart = function($container){
    // console.log("AnimationStart");
    var _$wait = $container.find(".wait");
    _$wait.each(function(){
      var __$this = $(this);
      var __delay = __$this.data("delay");
      var __timeout = setTimeout(function(){
        __$this
          .removeClass("wait")
          .addClass("animation");
        clearTimeout(__timeout);
      }, __delay)
    });

  };

  var ResetAnimate = function($container){
    // console.log("ResetAnimate");
    var _$animate = $container.find(".animation");
    var _$animating = $container.find(".animating");
    _$animate.each(function(){
      var __$this = $(this);
      __$this
        .addClass("wait")
        .removeClass("animation");
    });
    _$animating.each(function(){
      var __$this = $(this);
      __$this
        .addClass("waiting")
        .removeClass("animating");
    });
  };

  var setAnimation = function(){
    // console.log("setAnimation:");
    var $section = $(".waiting");
    var sectionLen = $section.length;
    var timing, _height, mainHeight, mainTop;
    if(_isSP){
      _height = $window.height();
      mainTop = ($window.height() - mainHeight) / 2;
      timing = mainHeight - 100;
    }else{
      _height = $window.height();
      mainTop = 0;
      timing = _height - (_height / 4);
    }

    for(var i = 0; i < sectionLen; i++){
      var $wait = $($section[i]);
      var offsetTop;

      offsetTop = $wait.offset().top;
      if(
        $window.scrollTop() + timing >= offsetTop
      ){
        var _delay = $wait.data("delay");
        if(_delay === void 0){
          _delay = 0;
        }
        $wait.delay(_delay).queue(function(){
          var __$this = $(this);
          __$this.removeClass("waiting").addClass('animating');
          __$this.dequeue();
        });
      }else{
        //
      }
    }
  };

  var AnimationScroller = function(){
    setAnimation();
  };

  $window.on("scroll", AnimationScroller);
  AnimationScroller();


};

window.addEventListener("load", Init);